import React from 'react';
import { orderBy } from 'lodash';
import { AutocompleteStyled, TextField } from '../../../components';
import { RangeDates } from '../../../components';
import { useTranslation } from 'react-i18next';
import { ISearchFiltres } from '../types';

interface IFiltreProps {
  types: string[];
  onChangeDescription: (value: string) => void;
  onChangeTypes: (types: string[] | undefined) => void;
  onChangeDate: (
    isExpeditionDate: boolean,
    startDate?: Date,
    endDate?: Date
  ) => void;
  onChangeSecretaryEntity: (value: string) => void;
  onChangeValidity: (value: string) => void;
  state: ISearchFiltres;
}

const FiltreSecondary = ({
  types,
  onChangeTypes,
  onChangeDate,
  onChangeDescription,
  onChangeSecretaryEntity,
  onChangeValidity,
  state
}: IFiltreProps) => {
  const { t } = useTranslation();
  const onChangeType = (e: any, value: any | null) => onChangeTypes(value);

  const onChangeDateLocal =
    (isExpeditionDate: boolean) => (startDate?: Date, endDate?: Date) => {
      onChangeDate(isExpeditionDate, startDate, endDate);
    };

  return (
    <div className='space-y-3'>
      <AutocompleteStyled
        multiple
        isOutlined
        options={orderBy(types)}
        label={t('pages.adsOffice.labelType')}
        onChange={onChangeType}
        getOptionLabel={(option: any) => option}
        renderInput={() => <></>}
        value={state.types || []}
      />
      <RangeDates
        label={t('pages.adsOffice.labelExpeditionDate')}
        labelFrom={t('pages.adsOffice.labelDateFrom')}
        labelTo={t('pages.adsOffice.labelDateTo')}
        onChangeDate={onChangeDateLocal(true)}
        startDate={state.expeditionDateStart}
        endDate={state.expeditionDateEnd}
      />
      <RangeDates
        label={t('pages.adsOffice.labelPublicationDate')}
        labelFrom={t('pages.adsOffice.labelDateFrom')}
        labelTo={t('pages.adsOffice.labelDateTo')}
        onChangeDate={onChangeDateLocal(false)}
        startDate={state.publicationDateStart}
        endDate={state.publicationDateEnd}
      />
      <div>
        <TextField
          maxLength={100}
          isOutlined
          label={t('pages.adsOffice.labelDescription')}
          onChange={onChangeDescription}
          value={state.description || ''}
        />
      </div>
      <div>
        <TextField
          maxLength={50}
          isOutlined
          label={t('pages.adsOffice.labelSecretaryEntityName')}
          onChange={onChangeSecretaryEntity}
          value={state.secretaryEntityName || ''}
        />
      </div>
      <div>
        <TextField
          maxLength={50}
          isOutlined
          label={t('pages.adsOffice.labelValidity')}
          onChange={onChangeValidity}
          value={state.validity || ''}
        />
      </div>
    </div>
  );
};
export default FiltreSecondary;
